import { Flex, Spin } from 'antd'
import React, { useState } from 'react'
import useAsync from 'react-use/lib/useAsync'

import CreatorEarningSummary from '@/components/shared/creator-earning-summary'
import { EarningType } from '@/constants/earning-type'
import { FeatureKey } from '@/constants/feature-key'
import { readCreatorOverviewSummary } from '@/redux/creator-reports'
import { useAppDispatch, useAppSelector } from '@/redux/utils'

import { ReportsPageProps } from '../../hooks/use-report-search'
import SectionTitle from '../section-title'

export default function CreatorOverviewEarningSummary({ searchValues }: ReportsPageProps) {
  const { earningType = EarningType.GrossEarnings } = searchValues
  const { creatorOverviewSummary } = useAppSelector(state => state.creatorReports)
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)

  const { startAt, endAt, creatorIds } = searchValues

  useAsync(async () => {
    setLoading(true)
    await dispatch(readCreatorOverviewSummary({
      startAt,
      endAt,
      creatorIds,
      permissionKey: FeatureKey.AnalyticsCreatorOverview,
    }))
    setLoading(false)
  }, [dispatch, startAt, endAt, creatorIds])

  return (
    <Flex vertical gap={16}>
      <SectionTitle
        title="Earning summary"
        tooltip="An overview of total earnings based on your managed Creators during this period"
      />
      <Spin spinning={loading}>
        <CreatorEarningSummary
          totalEarnings={creatorOverviewSummary?.[earningType].total}
          subscriptionsEarning={creatorOverviewSummary?.[earningType].subscription}
          tipsEarning={creatorOverviewSummary?.[earningType].tip}
          postsEarning={creatorOverviewSummary?.[earningType].post}
          messageCount={creatorOverviewSummary?.messageCount}
          postCount={creatorOverviewSummary?.postCount}
          showEarningCounts
        />
      </Spin>
    </Flex>
  )
}
